/* eslint-disable max-len */
import React from "react"
import BaseSvgIcon from "./Base"

const Logout = (props) => {
  return (
    <BaseSvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M15.855 15.4355V22.1347H2.01124L2.01124 1.86532H15.855L15.855 8.56452H16.6693V1.00645H1.1969L1.1969 22.9936H16.6693V15.4355H15.855Z"
        fill="black"
        stroke="black"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.7188 11.3498H10.3509C9.92978 11.3498 9.58887 11.6416 9.58887 12.0021C9.58887 12.3626 9.92978 12.6545 10.3509 12.6545H20.7188L18.7736 14.3197C18.4728 14.5772 18.4728 14.9892 18.7736 15.2467C18.9139 15.3668 19.1145 15.4355 19.315 15.4355C19.5156 15.4355 19.7161 15.3668 19.8565 15.2467L23.1052 12.4656C23.406 12.2081 23.406 11.7961 23.1052 11.5386L19.8765 8.75764C19.5757 8.50014 19.0944 8.50014 18.7936 8.75764C18.4928 9.01514 18.4928 9.42714 18.7936 9.68464L20.7188 11.3498Z"
        fill="black"
        stroke="black"
        strokeWidth="0.4"
      />
    </BaseSvgIcon>
  )
}

export default Logout
